module.exports = __webpack_public_path__ + "static/media/airplane.3415faba.svg";